export default "__VITE_ASSET__DBcvvZxb__"